import { mdiMagnify } from "@mdi/js";
import { Show, createMemo } from "solid-js";
import { Card } from "~/components/ui/card";
import { Icon } from "~/components/ui/icon";
import { TextField, TextFieldDescription, TextFieldInput } from "~/components/ui/text-field";
import { useDocumentContext } from "../../../providers/context";

export function SearchBar() {
	const { search, onSearch, searchAmount, searches } = useDocumentContext();

	const keywords = createMemo(() => {
		const words = new Set(searches());
		words.delete(search());

		return Array.from(words);
	});

	return (
		<>
			<TextField class="px-4 lg:px-0 lg:mb-4">
				<TextFieldInput
					type="text"
					placeholder="Zoek artikelen..."
					value={search()}
					onInput={onSearch}
				/>
				<Show when={search()}>
					<TextFieldDescription class="mt-2">Zoekresultaten - {searchAmount()} gevonden</TextFieldDescription>
				</Show>
			</TextField>
			<Show when={keywords().length > 0}>
				<Card class="mb-4 p-3 shadow-none bg-gray-100 border-none rounded-sm">
					<Icon
						class="mr-2"
						path={mdiMagnify}
						size="sm"
					/>
					Ook gezocht op: {keywords().join(", ")}
				</Card>
			</Show>
		</>
	);
}
